import SummaryTab from './SummaryTab';

interface SummaryHeaderProps {
  compliances: Record<string, number>;
  explanations?: Record<string, string>;
  activeTab: number;
  onTabChange: (newValue: number) => void;
}

const SummaryHeader = ({
  compliances,
  explanations,
  activeTab,
  onTabChange,
}: SummaryHeaderProps) => {
  const allCompliances = [
    {
      key: 'returned',
      label: 'Devueltos',
      dotClass: 'bg-[#f97316]',
      badgeClass: 'bg-[#fff7ed] text-[#9a3412]',
      explanation: 'El envío fue devuelto al depósito tras un intento de entrega fallido o por cancelación.',
    },
    {
      key: 'unexpected',
      label: 'Inesperados',
      dotClass: 'bg-[#ef4444]',
      badgeClass: 'bg-[#fef2f2] text-[#991b1b]',
      explanation: 'El envío no figura asignado a este conductor o ya fue reportado como entregado.',
    },
    {
      key: 'nonReported',
      label: 'No Reportados',
      dotClass: 'bg-[#7f1d1d]',
      badgeClass: 'bg-[#fef2f2] text-[#7f1d1d]',
      explanation:
        explanations?.nonReported ||
        'El envío no fue reportado por el conductor durante el proceso de rendición.',
    },
  ];

  const activeTabs = allCompliances.filter(tab => Object.keys(compliances).includes(tab.key));

  return (
    <div className='w-full overflow-x-auto overflow-y-hidden [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden'>
      <div className='flex items-end gap-1 px-0 min-w-max pb-[1px]'>
        {activeTabs.map((tab, index) => (
          <SummaryTab
            key={tab.key}
            label={tab.label}
            count={compliances[tab.key] || 0}
            dotClass={tab.dotClass}
            badgeClass={tab.badgeClass}
            explanation={tab.explanation}
            isActive={activeTab === index}
            onClick={() => onTabChange(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default SummaryHeader;
